import normalizeString from '@/core/lib/stringHelpers/stringHelpers';

export default normalizeString;
